import { Accessor, LocaleX } from "IZOX/STATIC";
import { HStack, XButton, XText } from "IZOX/_X";
import { SysTheme } from "__SYSDefault/Theme";
import _ from "lodash";
import { useCallback, useEffect, useState } from "react";
import { FaCheck, FaCircle } from "react-icons/fa";

/**
 * @typedef {import("IZOX/_X/XButton").xbuttonparams} xbuttonparams
 * @typedef {import("IZOX/_X/XText").xtextparams}  xtextparams
 * @typedef {import("IZOX/__Typedef/common").lang} lang
 * @typedef {import("IZOX/STATIC/ZValidate").fvalidate} fvalidate
 * 
 * @typedef {Object} qradioparams
 * @property {String} name
 * @property {any} refValue
 * @property {any} defaultValue
 * @property {Function} _onChange
 * @property {Function} _onSetDefault
 * @property {any} formValue
 * @property {String} color
 * @property {String} bColor
 * @property {Number} size
 * @property {"square" | "circle"} radioStyle
 * @property {xtextparams} labelParam
 * @property {lang} label
 * 
 * @param {qradioparams & xbuttonparams} param0
 * @returns 
 */
function QFRadio({
  name = undefined,
  _onChange = null,
  _onSetDefault = null,
  defaultValue = undefined,
  formValue = {},
  color = SysTheme.BGColors.Primary,
  bColor = SysTheme.Colors.Primary,
  bgColor = SysTheme.BGColors.Primary,
  size = 18,
  style = undefined,
  radioStyle = "circle",
  refValue = true,
  labelParam = {},
  label = undefined,
  updateVia = undefined, 
  updateField = undefined,
  forceUpdateField = undefined,
  performanceBoost = undefined,
  ...others
}){

  useEffect(() => {
    if(defaultValue) {
      _onSetDefault?.(name, defaultValue ?? false);
      setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  const [value, setValue] = useState(defaultValue);

  const getRound = useCallback(() => {
    switch(radioStyle){
      default: case "square": return 3;
      case "circle": return 50;
    }
  }, [radioStyle]);

  const renderCheck = () => {
    if(value !== refValue) return;
    switch(radioStyle){
      default: case "square": return <FaCheck color={bColor}/>;
      case "circle": return <FaCircle color={bColor} style={{padding: 1}}/>;
    }
  };

  useEffect(() => {
    let _value = Accessor.Get(formValue, name);
    setValue(_value);
  }, [formValue, name]);

  if(_.isUndefined(name)) return null;

  let { readOnly } = others;

  return (
    <XButton padding={0} {...others} 
      onPress={() => {
        if(readOnly) return;
        _onChange(name, refValue);
      }} 
      round={getRound()}
      style={{
        borderWidth: 2,
        borderColor: bColor,
        backgroundColor: value === refValue ? color : bgColor,
        width: size,
        height: size,
        ...style
      }} notInjectColor>
      <HStack>
        {renderCheck()}
        {label && 
          <XText {...labelParam}>
            {LocaleX.Parse(label)}  
          </XText>}
      </HStack>
    </XButton>
  );

}

export default QFRadio;